import { render, staticRenderFns } from "./cloze.vue?vue&type=template&id=02a7d647&scoped=true"
import script from "./cloze.vue?vue&type=script&lang=js"
export * from "./cloze.vue?vue&type=script&lang=js"
import style0 from "./cloze.vue?vue&type=style&index=0&id=02a7d647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a7d647",
  null
  
)

export default component.exports